/**
 * Design System - Color Tokens
 * Портировано из WEB_DESIGN_SYSTEM_GUIDE.md
 */

export const colors = {
  // Primary - из Flutter design system (VinpropColors)
  primary: '#2563EB',
  primaryLight: '#3B82F6',
  primaryDark: '#1D4ED8',
  primaryHover: '#1D4ED8',
  
  // Flutter VinpropColors
  mainBlue: '#404C76',
  mainBlueLight: '#0E7BC0',
  greyButton: '#F7F6FF',
  greyLight: '#C8C8C8',
  greyVeryLight: '#EDEDED',
  shadowGrey: '#F9FAFF',
  blueLight: '#5398CF',
  greyBackground: '#E1E4EF',
  lightColor: '#FCFDFF',
  buyingGuideBlue: '#4681BE',

  // Secondary  
  secondary: '#059669',
  secondaryLight: '#10B981',
  secondaryDark: '#047857',

  // Accent
  accent: '#F59E0B',
  accentLight: '#FBBF24',
  accentDark: '#D97706',

  // Text
  textPrimary: '#1F2937',
  textSecondary: '#6B7280',
  textTertiary: '#9CA3AF',
  textWhite: '#FFFFFF',
  textDisabled: '#D1D5DB',

  // Background
  backgroundWhite: '#FFFFFF',
  backgroundGray: '#F9FAFB',
  backgroundLight: '#F3F4F6',
  backgroundDark: '#E5E7EB',

  // Semantic
  success: '#10B981',
  successLight: '#34D399',
  successDark: '#059669',

  warning: '#F59E0B',
  warningLight: '#FBBF24',
  warningDark: '#D97706',

  error: '#EF4444',
  errorLight: '#F87171',
  errorDark: '#DC2626',

  info: '#3B82F6',
  infoLight: '#60A5FA',
  infoDark: '#2563EB',

  // Borders
  border: '#E5E7EB', // Алиас для borderLight
  borderLight: '#E5E7EB',
  borderMedium: '#D1D5DB',
  borderDark: '#9CA3AF',

  // Special
  overlay: 'rgba(0, 0, 0, 0.5)',
  overlayLight: 'rgba(0, 0, 0, 0.3)',
  white: '#FFFFFF',
  black: '#000000',
} as const

export type ColorToken = keyof typeof colors
